/**
 * @deprecated use window.fetch instead. i.e., fetch(url,{ body: payload, credentials: "include", headers: { "Content-Type": "application/json", method: "POST" }
 * @param {string} url - api request url (including any query strings)
 * @param {object} payload - data to save
 * @param {object} additionalConfig - any additional configurations for requests
 * @returns { data, error } object with data from API in data key, and any error in error key
 */
const postAsyncRequest = async (url = "", payload = undefined, additionalConfig = {}) => {
  try {
    const urlObj = new URL(`${window.gxApiConnection}${url.startsWith("/") ? url : `/${url}`}`);
    if (additionalConfig.params) {
      Object.entries(additionalConfig.params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          urlObj.searchParams.append(key, String(value));
        }
      });
    }
    const fetchResponse = await window.fetch(urlObj.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include",
      body: payload ? JSON.stringify(payload) : undefined,
    });
    return {
      status: fetchResponse.status,
      statusText: fetchResponse.statusText,
      data: await fetchResponse.json()
    };
  } catch (error) {
    return { status: 500, statusText: "", data: {} };
  }
};

export default postAsyncRequest;
